import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage } from "gatsby-plugin-image";
import Container from "../../atoms/Container";
import styled from "styled-components";
import { graphql } from "gatsby";
import SliceImage from "./shared-slices/SliceImage.js";

const Holder = styled.div``;

const ArticleGrid = styled.div`
  
  @media (${(props) => props.theme.breakpoints.md}) {
    display: grid;
    grid-template-columns: 2fr 3fr;
  }
`;

const ImageHolder = styled.div`
  margin: 2rem 0;
  grid-column: 2 / 3 ;

  @media (${(props) => props.theme.breakpoints.md}) {
    padding-left: 0.5rem;
  }
`;

const SliceImagePerspective = ({ slice }) => {
  const image = slice.primary.image.gatsbyImageData;
  const alt = slice.primary.image.alt;

  return (
    <Holder>
        <ArticleGrid>
          <ImageHolder>
            <SliceImage slice={slice} />
          </ImageHolder>
        </ArticleGrid>
    </Holder>
    );
};

SliceImagePerspective.propTypes = {
  slice: PropTypes.object.isRequired,
};

export default SliceImagePerspective;

export const query = graphql`
  fragment SliceImagePerspective on PrismicPerspectiveDataBodyImage {
    id
    slice_type
    primary {
      image {
        gatsbyImageData(placeholder: BLURRED)
        alt
      }
    }
  }
`;

